import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [{
    path: '*',
    redirect: '/'
  }, {
    path: '/',
    name: 'PageView',
    component: resolve => require(['@/view/PageView'], resolve),
    children: [{
        path: '/',
        redirect: '/home'
      }, {
        path: '/home',
        name: 'home',
        component: resolve => require(['@/view/HomePage'], resolve),
        meta: {
          title: '首页'
        }
      }, {
        path: '/software',
        name: 'software',
        component: resolve => require(['@/view/Software'], resolve),
        meta: {
          title: '软件产品'
        },
        children: [{
            path: '/software',
            redirect: '/software/smartTown'
          },
          {
            path: '/software/smartTown',
            name: 'software',
            component: resolve => require(['@/view/Software_smartTown'], resolve),
            meta: {
              title: '软件产品丨电商系统'
            }
          },
          {
            path: '/software/bigData',
            name: 'software',
            component: resolve => require(['@/view/Software_bigData'], resolve),
            meta: {
              title: '软件产品丨工厂管理系统'
            }
          }
        ]
      }, {
        path: '/service',
        name: 'service',
        component: resolve => require(['@/view/Service'], resolve),
        meta: {
          title: '公司业务'
        },
        children: [{
            path: '/service',
            redirect: '/service/governmentInformationization'
          },
          {
            path: '/service/governmentInformationization',
            name: 'service',
            component: resolve => require(['@/view/Government_informationization'], resolve),
            meta: {
              title: '公司业务丨政务信息化'
            }
          },
          {
            path: '/service/SmartManagement',
            name: 'service',
            component: resolve => require(['@/view/Smart_management'], resolve),
            meta: {
              title: '公司业务丨智慧管理'
            }
          },
          {
            path: '/service/ECommerceSystem',
            name: 'service',
            component: resolve => require(['@/view/E_commerce_system'], resolve),
            meta: {
              title: '公司业务丨智慧管理'
            }
          },
          {
            path: '/service/InternetOfThingsSystem',
            name: 'service',
            component: resolve => require(['@/view/internet_of_things_system'], resolve),
            meta: {
              title: '公司业务丨物联网系统'
            }
          },
          {
            path: '/service/EducationalSystem',
            name: 'service',
            component: resolve => require(['@/view/Educational_system'], resolve),
            meta: {
              title: '公司业务丨教育系统'
            }
          },
          {
            path: '/service/LogisticsSystem',
            name: 'service',
            component: resolve => require(['@/view/Logistics_system'], resolve),
            meta: {
              title: '公司业务丨物流系统'
            }
          },
        ]
      }, {
        path: '/newsinformation',
        name: 'newsinformation',
        component: resolve => require(['@/view/NewsInformation'], resolve),
        meta: {
          title: '新闻动态'
        }
      }, {
        path: '/companyintroduction',
        name: 'companyintroduction',
        component: resolve => require(['@/view/CompanyIntroduction'], resolve),
        meta: {
          title: '公司介绍'
        }
      }, {
        path: '/jobchance',
        name: 'jobchance',
        component: resolve => require(['@/view/JobChance'], resolve),
        meta: {
          title: '工作机会'
        }
      }, {
        path: '/contactusus',
        name: 'contactusus',
        component: resolve => require(['@/view/ContactUsus'], resolve),
        meta: {
          title: '联系我们'
        }
      },
      {
        path: '/servicedetail',
        name: 'servicedetail',
        component: resolve => require(['@/view/ServiceDetail'], resolve),
        meta: {
          title: '相关服务'
        }
      }
    ]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js